import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import { IBrokerKybSession } from "@rentiohq/shared-frontend/dist/types/payment.types";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { EField } from "./schema.kycVerification.types";

const getContactUpdate = (formData: any) => ({
  dateOfBirth: formData[EField.DateOfBirth],
  nationality: formData[EField.Nationality],
  ...formData[EField.Address],
  countryId: formData[EField.Address].country,
});

// Only ever leave the dashboard for Mangopay's own hosted pages
export const isMangopayUrl = (url: string) => {
  try {
    const { protocol, hostname, port } = new URL(url);

    return (
      protocol === "https:" &&
      port === "" &&
      (hostname === "mangopay.com" || hostname.endsWith(".mangopay.com"))
    );
  } catch {
    return false;
  }
};

// Mangopay sends the broker back to this same page, which then picks the flow up for this contact
// Only the page itself: query params a broker arrived with are not sent along to Mangopay
export const getKybReturnUrl = (contactId: number) => {
  const url = new URL(window.location.pathname, window.location.origin);
  url.searchParams.set("kybCallbackContactId", `${contactId}`);

  return url.toString();
};

// DEV-2801: Mangopay's hosted session does the KYB, the broker continues there
export const handleKybSession = (session: IBrokerKybSession) => {
  if (session.hostedUrl) {
    if (isMangopayUrl(session.hostedUrl)) {
      window.location.assign(session.hostedUrl);
    } else {
      showAlert({ type: "error", message: getLocalizedText("general.error") });
    }

    return;
  }

  showAlert({
    type: "info",
    message: getLocalizedText("form.kyb_receiver_as_broker.in_progress.title"),
  });
};

export const submitActionCreator =
  (
    contactId: number,
    asBroker = false,
    bankAccountId?: number,
    isLegalUser = false,
    kybReturnUrl?: string,
  ) =>
  (formData: any) => {
    if (isLegalUser) {
      return contactActions.kycContact.actions.start({
        contactId,
        bankAccountId,
        contact: getContactUpdate(formData),
        asBroker,
        asLegalUser: true,
        kybReturnUrl,
        onKybSession: handleKybSession,
      });
    }

    return contactActions.kycContact.actions.start({
      contactId,
      bankAccountId,
      contact: getContactUpdate(formData),
      idCardFront: formData[EField.IdCardFront][0],
      idCardBack: formData[EField.IdCardBack][0],
      asBroker,
      onSuccess: () => {
        showAlert({
          type: "success",
          message: getLocalizedText(
            "form.kyc_receiver_as_broker.success.title",
          ),
        });
      },
    });
  };
